import { render, staticRenderFns } from "./ChatDataDownloaded.vue?vue&type=template&id=085e1800"
import script from "./ChatDataDownloaded.vue?vue&type=script&lang=js"
export * from "./ChatDataDownloaded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports